import { render, staticRenderFns } from "./LatestPublications.vue?vue&type=template&id=6f8a225c&scoped=true&"
import script from "./LatestPublications.vue?vue&type=script&lang=js&"
export * from "./LatestPublications.vue?vue&type=script&lang=js&"
import style0 from "./LatestPublications.vue?vue&type=style&index=0&id=6f8a225c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f8a225c",
  null
  
)

export default component.exports